import * as React from "react";

const IconLargeArrowDown: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="40" height="24" viewBox="0 0 40 24"><polygon fill="currentColor" points="20 24 0 0 40 0 20 24"/></svg>};

export default React.memo(IconLargeArrowDown);
